import {
  BaseActionObject,
  StateNodeConfig,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const saveGlobalPlanSettingsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "saveGlobalPlanSettings",
    onDone: {
      target: "get_global_settings",
      actions: assign<Context, DoneInvokeEvent<any>>((_ctx, _evt) => ({
        snackbar: {
          message: "Settings saved",
          withUndo: false,
          error: false
        }
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("saveGlobalSettings", {
            messageData: ["save plan error"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
